// import deepPurple from '@material-ui/core/colors/deepPurple';
const theme = {
  colors: {
    primaryText: '#fff',
  },
  palette: {
    primary: {
      contrastText: '#fff',
      main: '#B65D0D',
      green: '#08be00',
    },
  },
  transparentBackground: {
    dark: 'rgba(0, 0, 0, 0.15)',
    light: 'rgba(255, 255, 255, 0.15)',
  },
};

export default theme;
